import { Fragment } from 'react';

import RichText from 'components/RichText';
import Text from 'components/Text';
import type { Product } from 'models/product';
import { is } from 'utils/helpers';

import { filterAdditionalTexts } from './helpers/productDataHelpers';

interface Props {
	className?: string;
	hasChemicalStatements: boolean;
	product: Product;
}

export default function ProductDetailsImportantInfo({
	className,
	hasChemicalStatements,
	product,
}: Props) {
	const { chemicalInformationResponse } = product;
	const additionalTexts = filterAdditionalTexts(product.additionalTexts);

	return (
		<div className={className}>
			{is.arrayWithLength(additionalTexts) && (
				<div className="richtext">
					{additionalTexts.map((text) => (
						<Fragment key={text.id}>
							{text.title && (
								<Text as="h3" styleAs="h4" className="pb-2">
									{text.title}
								</Text>
							)}
							{text.textFormatted && (
								<RichText html={text.textFormatted} className="text-md" />
							)}
						</Fragment>
					))}
				</div>
			)}
			{hasChemicalStatements && chemicalInformationResponse && (
				<>
					{chemicalInformationResponse.hazardStatements && (
						<Text as="h3" styleAs="p" className="mb-4 font-bold">
							{chemicalInformationResponse.hazardStatements}
						</Text>
					)}
					{chemicalInformationResponse.precationaryStatements && (
						<Text as="p" className="mt-3">
							{chemicalInformationResponse.precationaryStatements}
						</Text>
					)}
					{chemicalInformationResponse.supplementalHazardStatements && (
						<Text as="p" className="mt-3">
							{chemicalInformationResponse.supplementalHazardStatements}
						</Text>
					)}
				</>
			)}
		</div>
	);
}
ProductDetailsImportantInfo.displayName = 'ProductDetailsImportantInfo';
